import React, { useState, useEffect } from "react";
import "./generateHn.css";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { verifyHnNumber } from "../../modules/patientProfile/patientProfileThunk";
import { resetVerifyHnNumber } from "../../modules/patientProfile/patientProfileSlice";
import ToastPopup from "../../widgets/Toast/toastPopup";
import Widgets from "../../widgets";

const GenerateHn = ({ userId, setSelectedView, requestData, setRequestData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { verifyHnNumberSuccess, verifyHnNumberErr } = useSelector((state) => state.patientProfile);
  const [showConfirmModal, setshowConfirmModal] = useState(false);

  useEffect(() => {
    if (verifyHnNumberErr) {
      ToastPopup.error(verifyHnNumberErr);
    }
    if (verifyHnNumberSuccess && verifyHnNumberSuccess.status === "success") {
      ToastPopup.success(t("verified"));
      setSelectedView("patientProfileList");
    }
    dispatch(resetVerifyHnNumber());
  }, [verifyHnNumberSuccess, verifyHnNumberErr]);

  const handleHnChange = (e) => {
    const { value, selectionStart } = e.target;
    const newValue = value.replace(/[^0-9]/g, "").slice(0, 9);

    setRequestData((prevData) => ({
      ...prevData,
      relative: {
        ...prevData.relative,
        hnNumber: newValue,
      },
    }));

    requestAnimationFrame(() => {
      e.target.setSelectionRange(selectionStart, selectionStart);
    });
  };
  const convertToISODate = (date) => {
    let dateObj;
    if (typeof date === "object") {
      dateObj = new Date(date);
    } else if (typeof date === "string" && date.includes("/")) {
      const [day, month, year] = date.split("/");
      dateObj = new Date(`${year}-${month}-${day}`);
    } else {
      dateObj = new Date(date);
    }
    return dateObj.toISOString();
  };

  let updatedInfo = {
    personalInfo: {
      insuranceCategory: requestData.insuranceCategory,
      hnNumber: requestData.relative.hnNumber,
      dateOfBirth: convertToISODate(requestData.relative.dateOfBirth),
      gender: requestData.relative.gender,
      firstName: requestData.relative.firstName,
      lastName: requestData.relative.lastName,
    },
    address: {
      saveAs: requestData.userAddress?.saveAs ? requestData.userAddress.saveAs.charAt(0).toUpperCase() + requestData.userAddress.saveAs.slice(1) : undefined,
      personalCountryCode: requestData.userAddress?.personalCountryCode || "84",
      personalPhoneNumber: requestData.userAddress.personalPhoneNumber,
      street: requestData.userAddress.street,
      ward: requestData.userAddress.ward,
      district: requestData.userAddress.district,
      ...(requestData.userAddress.city && {
        city: requestData.userAddress.city,
      }),
      ...(requestData.userAddress.province && {
        province: requestData.userAddress.province,
      }),
      ...(requestData.userAddress.postalCode && {
        postalCode: requestData.userAddress.postalCode,
      }),
      ...(requestData.userAddress.officePhoneNumber && {
        officePhoneNumber: requestData.userAddress.officePhoneNumber,
        officeCountryCode: requestData.userAddress.officeCountryCode || "84",
      }),
    },
    nationalIdentity: {
      category: requestData.nationalId.category,
      number: requestData.nationalId.number,
      images: {
        front: requestData.nationalId.images.front,
        back: requestData.nationalId.images.back,
      },
    },
    insurances: requestData.insurance
      .filter((insuranceData) => insuranceData.isVerified)
      .map((insuranceData) => {
        let insurance = {
          company: insuranceData.insurance.company,
          image: insuranceData.insurance.image,
        };
        if (insuranceData._id) {
          insurance._id = insuranceData._id;
        }
        return insurance;
      }),
  };

  if (requestData.relative?._id) {
    updatedInfo.personalInfo._id = requestData.relative._id;
  }

  if (requestData.nationalId?._id) {
    updatedInfo.nationalIdentity._id = requestData.nationalId._id;
  }

  if (requestData.userAddress?._id) {
    updatedInfo.address._id = requestData.userAddress._id;
  }

  const handleVerify = (userId) => {
    console.log("updatedInfo", updatedInfo);
    dispatch(verifyHnNumber({ userId, updatedInfo }));
  };

  const handleSave = () => {
    if (requestData.relative?.hnNumber === null) {
      ToastPopup.error(t("plsEnterHn"));
      return;
    }
    if (!requestData.relative?.hnNumber.startsWith("8")) {
      ToastPopup.error(t("hnNumber8"));
      return;
    }
    if (requestData.relative?.hnNumber.length !== 9 || isNaN(requestData.relative?.hnNumber)) {
      ToastPopup.error(t("minHnDigit"));
      return;
    }
    setshowConfirmModal(true);
  };

  const handleCancelHN = () => {
    setshowConfirmModal(false);
  };

  const handleConfirmHN = () => {
    setshowConfirmModal(false);
    handleVerify(userId);
  };

  return (
    <div className="pdl-info verify gen-hn-container">
      <p className="pdl-title">{t("genHn")}</p>
      <div className="piv-id nat-id gen-hn-number">
        <p className="piv-subtitle">
          {t("hnNumber")}
          <span className="asterik">*</span>
        </p>
        <input className="piv-number" value={requestData.relative?.hnNumber} placeholder={t("enterHnNumber")} onChange={handleHnChange} />
      </div>
      <div className="save-speciality info">
        <div className="speciality-save" onClick={handleSave}>
          {t("submit")}
        </div>
      </div>
      <Widgets.ConfirmModal showModal={showConfirmModal} handleCancel={handleCancelHN} handleConfirm={handleConfirmHN} heading="confHnGen" description="askHnGen" postive />
    </div>
  );
};

export default GenerateHn;
